import { MRT_ShowHideColumnsMenu as ShadcnShowHideColumnsMenu } from '@talentmesh/table';
import { Button } from '@talentmesh/ui/components/button';
import { DropdownMenuContent, DropdownMenuTrigger, DropdownMenu } from '@talentmesh/ui/components/dropdown-menu';
import { TooltipContent, Tooltip, TooltipTrigger } from '@talentmesh/ui/components/tooltip';
import { Columns3Icon } from 'lucide-react';
import { useCandidatesTableContext } from '../../Contexts/CandidatesTableContext/CandidatesTableContext';

const EditColumnsButton = () => {
    const table = useCandidatesTableContext();

    return (
        <DropdownMenu>
            <Tooltip>
                <TooltipTrigger asChild>
                    <DropdownMenuTrigger asChild>
                        <Button
                            variant="ghost"
                            size="icon"
                            type="button"
                            data-cy="editColumnButton"
                            aria-label="Edit columns"
                        >
                            <Columns3Icon />
                        </Button>
                    </DropdownMenuTrigger>
                </TooltipTrigger>
                <TooltipContent side="bottom">Show/Hide Columns</TooltipContent>
            </Tooltip>
            <DropdownMenuContent
                align="start"
                className="w-full overflow-y-auto"
                onCloseAutoFocus={(e) => e.preventDefault()}
                side="bottom"
                data-cy="editColumnMenu"
            >
                <ShadcnShowHideColumnsMenu table={table} />
            </DropdownMenuContent>
        </DropdownMenu>
    );
};

export default EditColumnsButton;
